<template>
	<div>

		<div class="w-100 account-header">
			<h2 class="mb-none">{{user.displayname}}</h2>
			<a class="action" v-if="user.hasPermission" @click.prevent="form = true"><i class="el-icon-edit float-right"></i></a>
			<em v-if="isViewingOwnProfile">Name &amp; Bio</em>
		</div>


		<hr class="solid mt-xs">
		<div v-if="user.bio !== null && user.bio.length > 19" class="biography" v-html="user.bio"></div>
		<div v-if="user.bio === null || user.bio.length < 20">No details about {{user.firstname}} yet.</div>
		
		<div v-if="user.hasPermission" class="mt-4">

			<div v-if="profileVisibleInternal && user !== null" v-loading="thinking.visible">
				<div class="alert alert-default">
					<div class="row">
						<div class="col-lg-8">
							<p class="mb-0 p-0">
								Your name and bio above is currently visible to the public.
							</p>
						</div>
						<div class="col-lg-4 text-right">
							<el-switch v-model="profileVisibleInternal"
												 active-color="#13ce66"
												 inactive-color="#ff4949" style="top: 1px;">
							</el-switch>
						</div>
					</div>

				</div>
			</div>
			<div v-else>
				<div class="alert alert-default">
					<div class="row">
						<div class="col-lg-8">
							<p class="mb-0 p-0">
								Your name and bio above is currently hidden from the public.
							</p>
						</div>
						<div class="col-lg-4 text-right">
							<el-switch v-model="profileVisibleInternal"
												 active-color="#13ce66"
												 inactive-color="#ff4949" style="top: 1px;">
							</el-switch>
						</div>
					</div>					
				</div>
			</div>

			

		</div>

		<el-dialog title="Basic Info"
							 :visible.sync="form"
							 :width="modalWidth"
							 :close-on-click-modal="false"
							 :append-to-body="false">

			<div class="form row">
				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('first name')}]">
					<label>First Name*</label>
					<el-input v-model="data.firstname" name="first name" data-vv-as="first name" class="w-100" v-validate="'required'" />
					<span v-if="errors.has('first name')">{{errors.first('first name')}}</span>
				</div>
				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('middle name')}]">
					<label>Middle Name</label>
					<el-input v-model="data.middlename" name="middle name" data-vv-as="middle name" class="w-100" />
					<span v-if="errors.has('middle name')">{{errors.first('middle name')}}</span>
				</div>
				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('last name')}]">
					<label>Last Name*</label>
					<el-input v-model="data.lastname" name="last name" data-vv-as="last name" class="w-100" v-validate="'required'" />
					<span v-if="errors.has('last name')">{{errors.first('last name')}}</span>
				</div>
			</div>

			<el-alert type="info" show-icon title="Your display name is how others will see you on the site." class="mb-2" />
			<div class="form row">

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('display name')}]">

					<label>Display Name*</label>
					<el-input v-model="data.displayname" name="display name" data-vv-as="display name" class="w-100" v-validate="'required'" />
					<span v-if="errors.has('display name')">{{errors.first('display name')}}</span>
				</div>
			</div>

			<div class="form row">
				<div class="form-group col-12">
					<summernote name="bio" v-on:change="value => { data.bio = value }" :model="data.bio"></summernote>
				</div>

			</div>

			<el-alert :title="serverError" v-if="serverError"
								type="error"
								effect="dark"
								show-icon
								:closable="false" class="mt-4">
			</el-alert>

			<span slot="footer" class="dialog-footer">
				<el-button :disabled="thinking.save" @click="form = false">Cancel</el-button>
				<el-button :loading="thinking.save" type="primary" @click="submit">Confirm</el-button>
			</span>
		</el-dialog>
	</div>


</template>

<script>
	import { rest } from "@/utilities/rest.js";
	import { mapGetters } from "vuex";
	import SummerNote from "@/components/Summernote";
	export default {
		name: "name-bio",
		data() {
			return {
				view: "template",
				form: false,
				profileVisibleInternal: null,
				data: {

				},
				serverError: null,
				thinking: {
					save: false,
					visible: false
				}
			}
		},

		components: {
			[SummerNote.name]: SummerNote
		},

		created() {
			this.data = JSON.parse(JSON.stringify(this.user));
			this.profileVisibleInternal = this.data.profileVisible;
		},

		methods: {

			updateProfileVisibility(method) {
				let payload = {
					method: method,
					userId: this.user.userId
				};

				this.thinking.visible = true;
				rest.post("Account", "/UpdateProfileVisibility", "json", JSON.stringify(payload)).done(response => {
					setTimeout(() => {
						this.$message.success("Changes have been saved.");
					}, 1000);
					//this.$emit("fetch", "nameBio");
				}).always(() => {
					this.thinking.visible = false;
				});
			},

			submit() {
				this.$validator.validateAll().then(valid => {
					if (valid) {
						this.thinking.save = true;
						rest.post("Account", "/UpdateNameBio", "json", JSON.stringify(this.data)).done(response => {
							this.form = false;
							setTimeout(() => {
								this.$message.success("Changes have been saved.");
							}, 1000);
							this.$emit("fetch", "nameBio");
						}).fail((error) => {
							console.log(error);
							this.serverError = JSON.parse(error.responseText);
						}).always(() => {
							this.thinking.save = false;
						})
					}
				});
			}
		},

		props: ["user", "isViewingOwnProfile"],
		computed: {
			...mapGetters({
				modalWidth: "modalWidth"
			})
		},

		watch: {
			form(val) {
				if (val) {
					this.data = JSON.parse(JSON.stringify(this.user));
					this.$validator.reset();
				}
			},
			profileVisibleInternal(newVal, oldVal) {
				if (oldVal !== null && oldVal !== undefined)
					this.updateProfileVisibility(newVal === true ? 'remove' : 'add');
			}
		}
	}
</script>